import { Subject } from "rxjs";
import * as i0 from "@angular/core";
var BreadcrumbService = /** @class */ (function () {
    function BreadcrumbService() {
        this.cacheEtiquetas = new Map();
        this._cacheEtiquetasObs = new Subject();
    }
    Object.defineProperty(BreadcrumbService.prototype, "cacheEtiquetasObservable", {
        get: function () {
            return this._cacheEtiquetasObs.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbService.prototype.refrescarMarcasDeLugar = function () {
        this.traducirMarcasDeLugar(this.obtenerTraduccionMarcasDeLugar());
    };
    BreadcrumbService.prototype.traducirMarcasDeLugar = function (etiquetas) {
        this.almacenarEtiquetas(etiquetas);
        this._cacheEtiquetasObs.next(this.extraerEtiquetasDeCache());
    };
    BreadcrumbService.prototype.obtenerTraduccionMarcasDeLugar = function () {
        return this.extraerEtiquetasDeCache();
    };
    BreadcrumbService.prototype.limpiarCache = function () {
        this.cacheEtiquetas.clear();
    };
    BreadcrumbService.prototype.almacenarEtiquetas = function (etiquetas) {
        var _this = this;
        Object.keys(etiquetas).forEach(function (clave) {
            _this.cacheEtiquetas.set(clave, etiquetas[clave]);
        });
    };
    BreadcrumbService.prototype.extraerEtiquetasDeCache = function () {
        var arrayResultado = [];
        this.cacheEtiquetas.forEach(function (valor, clave) {
            arrayResultado[clave] = valor;
        });
        return arrayResultado;
    };
    BreadcrumbService.ngInjectableDef = i0.defineInjectable({ factory: function BreadcrumbService_Factory() { return new BreadcrumbService(); }, token: BreadcrumbService, providedIn: "root" });
    return BreadcrumbService;
}());
export { BreadcrumbService };
